<template>
  <div class="toasts" role="status" aria-live="polite" aria-atomic="false">
    <template v-if="toasts.length > 0">
        <transition-group>
          <div v-for="(toast, index) in toasts" :key="toast.id">
            <toast
              :index="index"
              :toast="toast"
              :arrayLength="toasts.length"
              @remove="remove"
              @removeNow="removeNow">
            </toast>
          </div>
        </transition-group>
    </template>
  </div>
</template>

<script>
  import eventbus from '../../eventbus'
  import docendo from '../../docendo'
  import toast from './Toast.vue'

  export default {
    components: {toast},
    data () {
      return {
        toasts: []
      }
    },
    computed: {
      messageFromOtherComponent () {
        return eventbus.toast
      }
    },
    watch: {
      messageFromOtherComponent () {
        const text = this.messageFromOtherComponent.text
        const status = this.messageFromOtherComponent.success
        const position = this.messageFromOtherComponent.position ? this.messageFromOtherComponent.position : null
        this.pushToast(text, status, position)
      }
    },
    methods: {
      pushToast (text, success, position) {
        this.toasts.push({
          id: Date.now(),
          text: text,
          success: success,
          position: position
        })
      },
      removeNow (id) {
        for (let i = 0; i < this.toasts.length; i++) {
          if (this.toasts[i].id === id) {
            this.toasts.splice(i, 1)
          }
        }
      },
      remove (id) {
        setTimeout(() => {
          for (let i = 0; i < this.toasts.length; i++) {
            if (this.toasts[i].id === id) {
              this.toasts.splice(i, 1)
            }
          }
        }, 6500)
      }
    },
    mounted () {
      docendo.bind('new_notification', data => {
        this.pushToast(data.message, true)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Manager.vue?09d77484